var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __decorate, __metadata } from "tslib";
import chmService from "@/core/services/chmService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { GrupoActions } from "@/store/enums/chmEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let GrupoModule = class GrupoModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = GrupoActions.DOWNLOAD_PLANILHA]() {
        return new Promise((resolve, reject) => {
            chmService.getFile("Grupo/DownloadPlanilhaModelo")
                .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Planilha_Modelo_Grupo.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve(response);
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors);
                }
                else {
                    reject("Erro ao baixar a planilha.");
                }
            });
        });
    }
    [_b = GrupoActions.UPLOAD_PLANILHA](file) {
        const formData = new FormData();
        formData.append('file', file); // Adiciona o arquivo ao FormData
        return new Promise((resolve, reject) => {
            chmService.postFile("Grupo/ImportarPlanilha", formData)
                .then(({ data }) => {
                resolve(data); // Sucesso
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors); // Rejeita com o erro
                }
                else {
                    reject("Erro ao enviar a planilha.");
                }
            });
        });
    }
    [_c = GrupoActions.POST_GRUPO](data) {
        return new Promise(resolve => {
            chmService.post("Grupo/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = GrupoActions.PUT_GRUPO](data) {
        return new Promise(resolve => {
            chmService.put("Grupo/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = GrupoActions.DELETE_GRUPO](data) {
        return new Promise(resolve => {
            chmService.delete("Grupo/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = GrupoActions.DELETE_RANGE_GRUPO](data) {
        return new Promise(resolve => {
            chmService.delete("Grupo/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = GrupoActions.FILTER_GRUPO](data) {
        return new Promise(resolve => {
            chmService.post("Grupo/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = GrupoActions.GET_GRUPO]() {
        return new Promise(resolve => {
            chmService.get("Grupo/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = GrupoActions.GETWITHDISABLED_GRUPO]() {
        return new Promise(resolve => {
            chmService.get("Grupo/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = GrupoActions.GET_BY_ID_GRUPO](data) {
        return new Promise(resolve => {
            chmService.get("Grupo/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GrupoModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [File]),
    __metadata("design:returntype", void 0)
], GrupoModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GrupoModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GrupoModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GrupoModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GrupoModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GrupoModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GrupoModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GrupoModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GrupoModule.prototype, _k, null);
GrupoModule = __decorate([
    Module
], GrupoModule);
export default GrupoModule;
//# sourceMappingURL=GrupoModule.js.map